import styled from "@emotion/styled";

import ActionButton from "metabase/components/ActionButton";

export const FormButton = styled(ActionButton)`
  margin-right: 0.5rem;
`;
